<template>
  <v-app id="inspire">
    <div class="leads-wrap">
      <v-layout>
        <v-flex>
          <h2 class="headline">Leads</h2>
        </v-flex>
        <v-btn class="header-btn-back mr-0 mb-3 mt-0" @click="$router.go(-1)">
          <v-icon class="header-btn-back-icon">navigate_before</v-icon>
          Back
        </v-btn>
      </v-layout>
      <v-flex class="header-search-single">
        <v-layout wrap>
          <v-flex xs6 class="inv-wrap-search">
            <v-text-field
              class="inv-search-field"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
              @input="typing = true"
            >
            </v-text-field>
          </v-flex>
          <v-layout md6 xs12>
            <v-spacer></v-spacer>
          </v-layout>
        </v-layout>
      </v-flex>
      <v-card>
        <!-- tools table -->
        <v-data-table
          :headers="headers"
          :items="items"
          :options.sync="options"
          :server-items-length="totalItems"
          :loading="loading"
          loader-height="2"
          :footer-props="{'items-per-page-options': [10, 20, 50]}"
          class="elevation-1 table-org my-sticky-last-column-table"
          :header-props="{ 'sort-icon': 'arrow_downward' }"
          mobile-breakpoint="100"
        >
          <template v-slot:item="{item}">
            <tr class="items-body-row">
              <td style="min-width: 120px;">
                <v-icon
                  color="orange"
                  style="font-size:13px;"
                >
                  fiber_manual_record
                </v-icon>
              </td>
              <td>
                {{ item.first_name }}
              </td>
              <td>
                {{ item.last_name }}
              </td>
              <td>{{ item.email }}</td>
              <td>
                <span v-if="!no_data.includes(item.created_at)">{{ onlyDate(item.created_at) }}</span>
                <em v-else class="grey--text">No data</em>
              </td>
              <td>
                <v-flex style="min-width: 210px;">
                  <v-flex
                    @click="view(item)"
                    class="pr-3 action-link"
                    >View <v-icon>visibility</v-icon>
                  </v-flex>
                  <v-flex
                    @click="vEmit({ name: 'DeleteLead', data: item })"
                    class="pr-3 action-link error--text"
                    >Delete <v-icon color="error">delete</v-icon>
                  </v-flex>
                  <v-flex
                    @click="vEmit({ name: 'ConvertLead', data: item })"
                    class="action-link success--text"
                    >Convert <v-icon color="success">swap_horiz</v-icon>
                  </v-flex>
                </v-flex>
              </td>
            </tr>
          </template>
          <template
            slot="no-data"
            v-if="error_code == 404 || error_code == 500"
          >
            <v-btn color="primary" @click="initialize()">Reset</v-btn>
          </template>
        </v-data-table>
      </v-card>

      <delete-lead @done="initialize"></delete-lead>
      <convert-lead @done="initialize"></convert-lead>
    </div>
  </v-app>
</template>

<script>
import ApiService from "@/common/api.service"
import DeleteLead from "./DeleteLead"
import ConvertLead from "./ConvertLead"
import _ from "lodash"
import { mapActions } from 'vuex'

export default {
  name: "Leads",
  components: {
    DeleteLead,
    ConvertLead
  },
  data() {
    return {
      dialog: false,
      no_data: [null, "", undefined, "null"],
      error_code: "",
      headers: [
        { text: "Status", value: "status", sort_column: 4 },
        { text: "First Name", value: "first_name", sort_column: 1 },
        { text: "Last Name", value: "last_name", sort_column: 2 },
        { text: "Email", value: "email", sort_column: 3 },
        { text: "Date Created", value: "created_at", sortable: false, width: "110px" },
        { text: "Actions", value: "details", sortable: false, align: "left" }
      ],
      items: [],
      totalItems: 0,
      search: "",
      options: {},
      loading: false,
      draw: 0,
      tableData: {
        draw: 0,
        length: 10,
        search: "",
        page: 0,
        column: 0,
        dir: "asc"
      },
      statuses: ["Active", "Inactive"],
      selectedStatuses: ["Active"],
    };
  },

  watch: {
    options: {
      handler() {
        if (this.draw !== this.tableData.draw) {
          this.initialize();
        }
      },
      deep: true
    },
    search: _.debounce(function() {
      this.typing = false;
      if (this.draw !== this.tableData.draw) {
        this.options.page = 1;
        this.initialize();
      }
    }, 1000),
  },
  mounted() {
    this.initialize()
  },
  methods: {
    ...mapActions(['vEmit']),
    initialize() {
      this.loading = true;
      const { sortBy, sortDesc, page, itemsPerPage } = this.options;

      this.tableData.column = 0;
      if (
        !this.no_data.includes(sortBy) &&
        !this.no_data.includes(sortBy[0]) &&
        this.headers.some(i => i.value === sortBy[0] && i.sortable !== false)
      ) {
        this.tableData.column = this.headers.find(
          i => i.value === sortBy[0]
        ).sort_column;
      }
      this.tableData.dir = !this.no_data.includes(sortDesc) && sortDesc[0] === true ? "asc" : "desc";

      this.tableData.length = itemsPerPage;

      this.tableData.page = page;
      this.tableData.search = this.search;
      this.tableData.draw++;
      this.draw = this.tableData.draw;

      this.tableData.status = 'in_progress'

      ApiService.get("/client/clients", this.tableData)
        .then(response => {
          let data = response.data;
          this.draw++;
          this.items = data.clients.data;
          this.totalItems = data.clients.total;
          this.loading = false;
        })
        .catch(error => {
          this.error_code = error.response.status;
          console.log(error.message);
        });
    },
    go() {
      this.initialize();
    },
    clearFilters() {
      this.selectedStatuses = this.statuses;
      this.initialize();
    },
    view(item) {
      this.$router.push(`/lead/${item.id}/show/${item.client_registration_service_id}`);
    },
    onlyDate(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    titleCase(str) {
      return _.startCase(str.replace(/_/g, " "));
    }
  }
};
</script>
<style>
/**tools table**/
.leads-wrap div.datatable.table {
  margin-bottom: 0%;
}

</style>
